import * as React from 'react';

const MissedPickupIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18.101} height={27.152}>
    <g>
      <path
        d="M16.889 13.576L9.063 27.152 1.2 13.576A9.063 9.063 0 014.55 1.203a9.063 9.063 0 014.507-1.2 9.052 9.052 0 019.039 9.064 9.048 9.048 0 01-1.207 4.509zM9.06 23.863l6.4-11.109a7.409 7.409 0 00.992-3.692 7.356 7.356 0 00-2.161-5.239A7.358 7.358 0 009.06 1.646a7.442 7.442 0 00-3.689.984 7.371 7.371 0 00-3.468 4.5 7.365 7.365 0 00.722 5.626z"
        data-name="Group 1509"
        fill="#0a1514"
      />
      <circle
        data-name="Ellipse 305"
        cx={2}
        cy={2}
        r={2}
        transform="translate(7.051 7.077)"
        fill="#0a1514"
      />
    </g>
  </svg>
);

export default MissedPickupIcon;
